import { Outlet } from 'react-router-dom';
import SiteHeader from './SiteHeader.jsx';
import SiteFooter from './SiteFooter.jsx';
import WhatsAppWidget from '../ui/WhatsAppWidget.jsx';

export default function Layout() {
  return (
    <>
      {/* Keyboard users can jump past the nav on every page. */}
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-amber focus:px-4 focus:py-2 focus:font-semibold focus:text-deep"
      >
        Skip to content
      </a>
      <SiteHeader />
      <main id="main">
        <Outlet />
      </main>
      <SiteFooter />
      {/* Outside <main> so it is not read as page content, and present on
          every route rather than duplicated per page. */}
      <WhatsAppWidget />
    </>
  );
}
